import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import  Swal  from 'sweetalert2'
import { GeocercasServiceService } from 'src/app/shared/services/geocercas-service/geocercas-service.service';
import { PuntosService } from 'src/app/shared/services/puntos-service/puntos.service';

import { MapToolsService } from '../../../services/map-tools.service';
import {MapaFullComponent } from '../../mapa-full/mapa-full.component'

@Component({
  selector: 'app-agregar-geocerca',
  templateUrl: './agregar-geocerca.component.html',
  styleUrls: ['./agregar-geocerca.component.scss']
})
export class AgregarGeocercaComponent implements OnInit {

  @Input() 
  geo: any;
  descripcion: String = ''
  coordenadas:String = ''

  params = {
    nombre_geocerca: null,
    coordenadas:null
  }

  public loading: boolean = false;
  public alertFail: boolean = false;
  public alertSuccess: boolean = false;
  public alertMsg: string = '';

  constructor(
    public geocercasService:GeocercasServiceService,
    private maptoolsservice:MapToolsService,
    private mapaFull:MapaFullComponent
  ) { }

  ngOnInit(): void {
    //this.estructurarGeo()
    //console.log(this.geo)
  }
  ngOnChanges(changes: SimpleChanges) {
    //console.log(changes)
  }

  popEliminarGeocerca(){
    this.geo.isOpen = false
    Swal.fire({
      title: 'Atención!, Esta Seguro de Eliminar?',
      text: 'GeoID: '+ this.geo.cod_geocerca+ ' Descripción: '+ this.geo.des_geocerca,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, Borrar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.geocercasService.deleteGeocerca(this.geo.cod_geocerca).subscribe(res => {
          console.log(res)
          if (res[0].existia_geocerca) {
            this.maptoolsservice.setGeocercas([]); 
            this.mapaFull.getMapGeocercas()
            
            Swal.fire(
              'Buen Trabajo!',
              'La geocerca fue eliminada correctamente',
              'success'
            )
          } else {
            Swal.fire(
              'Epa..!',
              'Ocurrio un error en el proceso',
              'error'
            )
          }
        }, function(error){
            
        });
      }
    })


  }

  estructurarGeo(){
/*     for (let index = 0; index < array.length; index++) {
      const element = array[index];
      
    } */
    let e = this.geo.puntos
    for (let i = 0; i < e.length; i++) {
      //console.log(e[i]);
      this.coordenadas += 'Coordenada ' + i + ': ' + e[i].lat + ',' + e[i].lng+' \n';
    } 

  }

  sendGeocerca(){
    //console.log(this.descripcion)
    //console.log(this.geo.puntos)
    let txt = []
    for (let i = 0; i < this.geo.puntos.length; i++) {
      txt.push(this.geo.puntos[i].lng+' '+this.geo.puntos[i].lat)
    } 
    let mod = txt.toString() //pasamos a cadena
    let corte = mod.split(",", 1)//hacemos el corte
    txt.push(corte[0])//empujamos al final lo que cortamos
    let cadfinal = txt.toString() //volvemos a convertir a string


    this.params.nombre_geocerca = this.descripcion,
    this.params.coordenadas = cadfinal //seteamos la cadena final para enviar al servicio
   
    this.loading = true;
    this.alertFail = false;
    this.alertSuccess = false;
    var error = false;

    if (!this.descripcion) {error = true; }
    if (error) {
      this.alertMsg = 'DEBE INGRESAR UNA DESCRIPCIÓN A LA GEOCERCA';
      this.alertFail = true;
      this.loading = false;
      setTimeout(() => {
        this.alertFail = false;
      }, 2000); 
      return;
    }
    this.geocercasService.addGeocerca(this.params).subscribe(res => {
      if (res) {
        this.loading = false;
        this.alertMsg = 'GEOCERCA CREADA';
        this.alertSuccess = true;

        this.descripcion = ''
        this.geo.puntos = []
        this.params.nombre_geocerca = null,
        this.params.coordenadas = null
        
        //this.maptoolsservice.setGeocercas([]); 
        this.mapaFull.getMapGeocercas()
        this.mapaFull.EliminarGeocerca(0, [])
        setTimeout(() => {
          this.alertSuccess = false;
          this.geo.isOpen = false
        }, 2000); 
      }else{

      }
    }, function(error){
        console.log(error);
        this.alertMsg = 'HA OCURRIDO UN PROBLEMA, FAVOR INTENTARLO MÁS TARDE';
        this.alertFail = true;
        this.loading = false;        
        return;
    });
    
  }

}
